import Colors from "@constants/Colors";
import styled from "styled-components";

export const MainFilterWrapper = styled.div`
  margin: 8px 16px 0px;
`;

export const FilterWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

export const CustomChipWrapper = styled.div`
  &.MuiButtonBase-root {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;

    background: ${Colors.neutral_gray_200};
    border-radius: 8px;
  }
`;

export const FilterTitleWrapper = styled.div`
  .customTitle {
    font-size: 16px;
    line-height: 24px;
  }
`;
